import { defineNuxtPlugin } from "#app";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import icons from "#build/fontawesome.mjs";
config.autoAddCss = false;
export default defineNuxtPlugin(() => {
  library.add(icons);
});
